export default function(){
    jQuery('.checkout-survey').each(function(){
        let $e          = jQuery(this);
        let $scrolldown = $e.find('[ref="scrolldown"]');
        let $box        = $e.find('[ref="box"]');
        let $answers    = $e.find('[ref="answers"]');

        let $entries    = $e.find('[ref="listEntry"]');
        let $submit     = $e.find('[ref="submit"]');
        let $error      = $e.find('[ref="error"]');

        $scrolldown.on('click', function(){
            jQuery('html, body').animate({
                scrollTop: $box.offset().top - 150
            });
        });

        $answers.on('click', function(){
            jQuery(this).parent().children('a').removeClass('active');
            jQuery(this).addClass('active');

            $error.removeClass('active');
        });

        $submit.on('click', function(){
            let data        = [];
            let success     = true;

            $entries.each(function(){
                let question        = jQuery(this).find('[ref="question"]').text();
                let $answersList    = jQuery(this).find('[ref="answersList"]');

                if( $answersList.length == 0 ){
                    let $notes = jQuery(this).find('[ref="notes"]');
                    if( $notes.length > 0){
                        data.push({
                            q: question, a: $notes.val()
                        });
                    }
                } else {
                    let $sel = $answersList.find('a.active');
                    if( $sel.length == 0 ){
                        success = false;
                        return false;
                    } else {
                        data.push({
                            q: question, a: $sel.text()
                        });
                    }
                }
            });

            if(!success){
                $error.addClass('active');
                return;
            }

            $box.addClass('loading');

            jQuery.post('/surveyFormSend', {
                data: data
            }, function(res){
                window.location.href = res.redirect;
            });
        });
    });
}